module.exports = __webpack_public_path__ + "img/pie-chart.6faebfa0.png";